var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87 9.5C9.35528 9.5 11.37 7.48528 11.37 5C11.37 2.51472 9.35528 0.5 6.87 0.5C4.38471 0.5 2.37 2.51472 2.37 5C2.37 7.48528 4.38471 9.5 6.87 9.5Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87 7C7.97456 7 8.87 6.10457 8.87 5C8.87 3.89543 7.97456 3 6.87 3C5.76543 3 4.87 3.89543 4.87 5C4.87 6.10457 5.76543 7 6.87 7Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 9.42L5.12002 13.12C5.1026 13.1903 5.07041 13.2561 5.02558 13.313C4.98074 13.3699 4.92431 13.4166 4.86002 13.45C4.79217 13.4795 4.71899 13.4946 4.64502 13.4946C4.57105 13.4946 4.49787 13.4795 4.43002 13.45L1.11002 12C1.04038 11.9671 0.979102 11.9188 0.930787 11.8588C0.882472 11.7988 0.848374 11.7287 0.831054 11.6536C0.813733 11.5786 0.813639 11.5005 0.830779 11.4254C0.847919 11.3503 0.881847 11.2801 0.930018 11.22L3.50002 8",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.37055L8.9 13.1205C8.9179 13.1921 8.95138 13.2587 8.99806 13.3158C9.04474 13.3728 9.10345 13.4188 9.17 13.4505C9.23599 13.4804 9.30758 13.4958 9.38 13.4958C9.45242 13.4958 9.52401 13.4804 9.59 13.4505L12.89 12.0005C12.9607 11.968 13.0228 11.9194 13.0714 11.8587C13.12 11.7979 13.1538 11.7267 13.17 11.6505C13.189 11.5761 13.1898 11.4982 13.1724 11.4234C13.155 11.3485 13.1199 11.279 13.07 11.2205L10.39 7.81055",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.ddd7341a0495a46fba5a614554431c0c.svg";
export { ForwardRef as ReactComponent };